import { useEffect, useState } from "react";
import { Button, Box, TextField, Avatar } from "@mui/material";
import { UseAdvertisments } from "./UseAdvertisments";
import { useNavigate, useLocation } from "react-router-dom";
import ProgressCom from "../../components/ProgressCom";
import Detail from "../../main/detail/Detail";
import { rsGotoLast, rsProgress, rsActiveMenu } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import { useSnackbar } from "notistack";
import useBreakpoints from "../../hooks/useBreakpoints";
import AdvertismentGroupAutoComplete from "../adv-group/AdvertismentGroupAutoComplete";

export default function AddAdvertisment(props) {
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();
  const location = useLocation();
  const [group, setAdvertisment] = useState();
  const { validate, addAdvertisment } = UseAdvertisments();
  const [msGotoLast, setMsGotoLast] = useRecoilState(rsGotoLast);
  const [progress, setProgress] = useRecoilState(rsProgress);
  const Grades = [1, 2, 3];
  const { isSmall } = useBreakpoints();

  const [state, setState] = useState({
    id: undefined,
    title: undefined,
    rowIndex: undefined,
    groupID: undefined,
    location: undefined,
    viewMedia: undefined,
    viewState: undefined,
    viewType: undefined,
    boxName: undefined,
  });

  const [imgState, setImgState] = useState({
    file: undefined,
    url: undefined,
  });

  const [errorState, setErrorState] = useState({
    title: false,
    id: false,
    groupID: false,
  });

  useEffect(() => {
    var lastrowIndex = Math.max.apply(
      Math,
      location.state?.items &&
        location.state?.items.map(function (o) {
          if (o) {
            return o.rowIndex;
          } else {
            return 1;
          }
        })
    );
    setState({
      ...state,
      rowIndex: lastrowIndex != -Infinity ? lastrowIndex + 1 : 1,
    });
  }, [location.state]);

  const handleChangeImage = (e) => {
    setImgState({
      ...imgState,
      file: e.target.files[0],
      url: URL.createObjectURL(e.target.files[0]),
    });
  };

  return (
    <Detail
      breadChilds={{
        title: "تبلیغات",
        childs: [
          { name: msActiveMenu.pageTitle, url: "/advertisments" },
          { name: " تبلیغات جدید", url: "/advertisments/addAdvertisment" },
        ],
      }}
    >
      {!group ? (
        <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={3}>
          <Box gridColumn={isSmall ? "span 12" : "span 2"}>
            <TextField
              fullWidth
              value={state.id ? state.id : ""}
              error={errorState.id}
              sx={{
                input: {
                  textAlign: "center",
                },
              }}
              label="ID"
              size="small"
              variant="outlined"
              onChange={(evt) => {
                setState({ ...state, id: evt.target.value });
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Box>
          {!isSmall && <Box gridColumn="span 10"></Box>}
          <Box gridColumn={isSmall ? "span 12" : "span 3"}>
            <TextField
              fullWidth
              value={state.title ? state.title : ""}
              error={errorState.title}
              label="عنوان"
              size="small"
              variant="outlined"
              onChange={(evt) => {
                setState({ ...state, title: evt.target.value });
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Box>
          {!isSmall && <Box gridColumn="span 9"></Box>}
          <Box gridColumn={isSmall ? "span 12" : "span 3"}>
            <AdvertismentGroupAutoComplete
              state={state}
              setState={setState}
              errorState={errorState.groupID}
            />
          </Box>
          {!isSmall && <Box gridColumn="span 9"></Box>}
          <Box gridColumn={isSmall ? "span 12" : "span 3"}>
            <TextField
              fullWidth
              value={state.location ? state.location : ""}
              label="موقعیت"
              size="small"
              variant="outlined"
              onChange={(evt) => {
                setState({ ...state, location: evt.target.value });
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Box>
          {!isSmall && <Box gridColumn="span 9"></Box>}
          <Box gridColumn={isSmall ? "span 12" : "span 3"}>
            <TextField
              fullWidth
              value={state.viewMedia ? state.viewMedia : ""}
              label="نمایشگر"
              size="small"
              variant="outlined"
              onChange={(evt) => {
                setState({ ...state, viewMedia: evt.target.value });
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Box>
          {!isSmall && <Box gridColumn="span 9"></Box>}
          <Box gridColumn={isSmall ? "span 12" : "span 3"}>
            <TextField
              fullWidth
              value={state.viewState ? state.viewState : ""}
              label="وضعیت"
              size="small"
              variant="outlined"
              onChange={(evt) => {
                setState({ ...state, viewState: evt.target.value });
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Box>
          {!isSmall && <Box gridColumn="span 9"></Box>}
          <Box gridColumn={isSmall ? "span 12" : "span 3"}>
            <TextField
              fullWidth
              value={state.viewType ? state.viewType : ""}
              label=" نمایش"
              size="small"
              variant="outlined"
              onChange={(evt) => {
                setState({ ...state, viewType: evt.target.value });
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Box>
          {!isSmall && <Box gridColumn="span 9"></Box>}
          <Box gridColumn={isSmall ? "span 12" : "span 3"}>
            <TextField
              fullWidth
              value={state.boxName ? state.boxName : ""}
              label="نام باکس"
              size="small"
              variant="outlined"
              onChange={(evt) => {
                setState({ ...state, boxName: evt.target.value });
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Box>
          {!isSmall && <Box gridColumn="span 9"></Box>}
          <Box
            gridColumn={isSmall ? "span 12" : "span 7"}
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              gap: 5,
            }}
          >
            <Box component="label">
              <Avatar
                sx={{
                  border: "1px solid #d9d9d9",
                  borderRadius: 3,
                  width: "100%",
                  height: imgState.url ? "300px" : "200px",
                  p: 1,
                }}
                src={imgState.url ? imgState.url : "/static/img/nobanner.jpg"}
                alt="img"
              />
              <input
                type="file"
                id="img"
                name="avatarName"
                accept="image/*"
                multiple
                onChange={handleChangeImage}
                hidden
              />
            </Box>
          </Box>
          {!isSmall && <Box gridColumn="span 5"></Box>}

          <Box
            gridColumn={isSmall ? "span 12" : "span 3"}
            sx={{ display: "flex", justifyContent: "flex-end" }}
          >
            <Button
              sx={{ mr: 2, width: "100px" }}
              variant="contained"
              color="secondary"
              onClick={() => {
                if (validate(state, setErrorState) == 200) {
                  setProgress(true);
                  setMsGotoLast(true);
                  addAdvertisment(state, imgState.file, () => {
                    navigate("/advertisments", {
                      state: { ...location.state, isBack: true },
                      replace: true,
                    });
                  });
                }
              }}
            >
              ثبت
            </Button>
            <Button
              sx={{ width: "100px" }}
              variant="outlined"
              color="secondary"
              onClick={() => {
                navigate("/advertisments", {
                  state: { ...location.state, isBack: true },
                  replace: true,
                });
              }}
            >
              بازگشت
            </Button>
          </Box>
        </Box>
      ) : (
        <ProgressCom></ProgressCom>
      )}
    </Detail>
  );
}
